export class Log {
    constructor(public id_session: number) {}
} 